module.exports = __webpack_public_path__ + "img/adv-icon.92928556.svg";